import "../../chunk-7QVYU63E.js";
var Product = /* @__PURE__ */ function(Product2) {
  Product2["NodeApi"] = "node-api";
  Product2["NftApi"] = "nft-api";
  Product2["SwapsApi"] = "swaps-api";
  Product2["BlockTimestampApi"] = "block-timestamp-api";
  Product2["TokenApi"] = "token-api";
  Product2["TransfersApi"] = "transfers-api";
  Product2["BundlerApi"] = "bundler-api";
  Product2["DebugApi"] = "debug-api";
  Product2["EmbeddedAccounts"] = "embedded-accounts";
  Product2["GasManagerApi"] = "gas-manager-api";
  Product2["TraceApi"] = "trace-api";
  Product2["PricesApi"] = "prices-api";
  Product2["TransactionSimulationApi"] = "transaction-simulation-api";
  Product2["TransactionReceiptsApi"] = "transaction-receipts-api";
  Product2["UserOperationsApi"] = "user-operations-api";
  Product2["Websockets"] = "smart-websockets";
  Product2["Webhooks"] = "webhooks";
  return Product2;
}({});
export {
  Product
};
//# sourceMappingURL=products.js.map